import { render, staticRenderFns } from "./TopChar.vue?vue&type=template&id=80f2d83a&"
import script from "./TopChar.vue?vue&type=script&lang=js&"
export * from "./TopChar.vue?vue&type=script&lang=js&"
import style0 from "./TopChar.vue?vue&type=style&index=0&id=80f2d83a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports